import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { Button, CircularProgress } from "@mui/material"
import { Box } from "@mui/system"
import React, { Fragment } from "react"
import { IActionButton } from "ui/model"
import { addImportant } from "ui/tools/common"

interface IPageHeaderDesktopButtonProps {
  index: number
  actionButton: IActionButton
  disabled?: boolean
  variant?: "text" | "outlined" | "contained"
  refresh?: () => any
}

export const PageHeaderDesktopButton = React.memo(
  ({ index, actionButton, variant, disabled, refresh }: IPageHeaderDesktopButtonProps) => {
    const [isLoading, setIsLoading] = React.useState(false)
    const isContained = variant === "contained"
    return (
      <Fragment key={index}>
        {index !== 0 && <Box sx={{ width: "1px", height: "2rem", borderLeft: theme => theme.palette.border }} />}
        <Button
          id={actionButton.id}
          disabled={disabled || actionButton.disabled || isLoading}
          variant={variant}
          sx={{
            "fontSize": addImportant(".8rem"),
            "& .MuiButton-startIcon": {
              mr: ".3rem"
            },
            "& .icon": {
              transition: "color 300ms",
              color: theme => (isContained ? theme.palette.specialText : theme.palette.text.primary2),
              fontSize: "1.2rem"
            },
            "&:hover .icon": { color: theme => (isContained ? theme.palette.primary.main : theme.palette.specialText) },
            "&.Mui-disabled .icon": { color: theme => theme.palette.text.disabled }
          }}
          startIcon={
            isLoading ? (
              <CircularProgress size="1rem" />
            ) : (
              <FontAwesomeIcon className="icon" icon={actionButton.icon} size="1x" />
            )
          }
          onClick={async () => {
            const result = actionButton.onClick()
            if (result instanceof Promise) {
              setIsLoading(true)
              await result
              setIsLoading(false)
            }
            if (refresh) {
              refresh()
            }
          }}>
          {actionButton.label}
        </Button>
      </Fragment>
    )
  }
)
